// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FailedAIMsgs_container__pLo\\+P {
  padding: 20px;
  max-width: 900px;
  margin: 0 auto;
  background: #f8f9fa;
  min-height: 100vh;
}

.FailedAIMsgs_header__spTRa {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 15px;
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.FailedAIMsgs_title__-JGt9 {
  margin: 0;
  font-size: 24px;
  color: #1a1a1a;
  font-weight: 600;
}

.FailedAIMsgs_filterTabs__jB0nU {
  display: flex;
  gap: 8px;
  background: #f1f3f4;
  padding: 4px;
  border-radius: 8px;
}

.FailedAIMsgs_filterButton__rmT1a {
  padding: 8px 16px;
  background: transparent;
  color: #5f6368;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.FailedAIMsgs_filterButton__rmT1a:hover {
  background: rgba(0,0,0,0.05);
  color: #202124;
}

.FailedAIMsgs_filterActive__BIBFF {
  background: white !important;
  color: #1a73e8 !important;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.FailedAIMsgs_filterActive__BIBFF:hover {
  background: white !important;
  color: #1557b0 !important;
}

/* Stats Summary Cards - New */
.FailedAIMsgs_statsSummary__mPS\\+x {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-bottom: 24px;
}

.FailedAIMsgs_statCard__O59eR {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  display: flex;
  align-items: center;
  gap: 15px;
  transition: transform 0.2s ease;
}

.FailedAIMsgs_statCard__O59eR:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.FailedAIMsgs_statIcon__eygCr {
  font-size: 32px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f3f4;
  border-radius: 12px;
}

.FailedAIMsgs_statInfo__xazhV {
  flex: 1 1;
}

.FailedAIMsgs_statLabel__wvQFw {
  font-size: 14px;
  color: #5f6368;
  margin-bottom: 4px;
}

.FailedAIMsgs_statValue__YRc\\+p {
  font-size: 28px;
  font-weight: 600;
  color: #202124;
  line-height: 1.2;
}

.FailedAIMsgs_statSubValue__Qauxs {
  font-size: 12px;
  color: #5f6368;
  margin-top: 2px;
}

.FailedAIMsgs_sortControls__xP-J7 {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  padding: 12px 16px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  align-items: center;
  flex-wrap: wrap;
}

.FailedAIMsgs_sortLabel__LZPHf {
  font-size: 14px;
  color: #5f6368;
  font-weight: 500;
}

.FailedAIMsgs_sortButton__KP\\+je {
  padding: 6px 14px;
  background: #f1f3f4;
  color: #5f6368;
  border: 1px solid transparent;
  border-radius: 20px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.FailedAIMsgs_sortButton__KP\\+je:hover {
  background: #e8eaed;
  color: #202124;
}

.FailedAIMsgs_sortActive__rBMHn {
  background: #e8f0fe !important;
  color: #1a73e8 !important;
  border-color: #1a73e8 !important;
}

.FailedAIMsgs_emptyState__Vmr6Y {
  text-align: center;
  padding: 60px 40px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.FailedAIMsgs_emptyStateIcon__5T5Jv {
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.7;
}

.FailedAIMsgs_emptyStateText__rnpdR {
  font-size: 18px;
  color: #5f6368;
  font-weight: 500;
}

.FailedAIMsgs_emptyStateSubtext__9nb\\+o {
  font-size: 14px;
  color: #9aa0a6;
  margin-top: 8px;
}

.FailedAIMsgs_questionCard__Opc7m {
  background: white;
  border: 1px solid #e8eaed;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  position: relative;
  transition: all 0.2s ease;
}

.FailedAIMsgs_questionCard__Opc7m:hover {
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  transform: translateY(-2px);
}

/* Resolved Card Styling */
.FailedAIMsgs_resolvedCard__mf5cZ {
  background: #f8f9fa;
  border-left: 6px solid #34a853;
  opacity: 0.95;
}

.FailedAIMsgs_resolvedCard__mf5cZ .FailedAIMsgs_questionText__5wZzu {
  color: #202124;
  opacity: 0.9;
}

/* All View Card Styling - New */
.FailedAIMsgs_allViewCard__Y9e1k {
  background: linear-gradient(to right, #ffffff, #f8f9fa);
  border: 1px solid #dadce0;
}

.FailedAIMsgs_allViewCard__Y9e1k .FailedAIMsgs_metadata__SFZyA {
  background: #f1f3f4;
  padding: 12px;
  border-radius: 8px;
  margin-top: 12px;
}

.FailedAIMsgs_failureBadge__iWUhf {
  position: absolute;
  top: -10px;
  right: 20px;
  background: #ea4335;
  color: white;
  border-radius: 20px;
  padding: 4px 14px;
  font-size: 12px;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(234, 67, 53, 0.3);
  animation: FailedAIMsgs_pulse__0p8Kc 2s infinite;
  z-index: 1;
}

@keyframes FailedAIMsgs_pulse__0p8Kc {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.FailedAIMsgs_questionText__5wZzu {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #202124;
  padding-right: 100px;
}

.FailedAIMsgs_attemptedAnswer__DSC3b {
  background: #fef7e0;
  padding: 14px;
  border-radius: 10px;
  margin-bottom: 16px;
  color: #5f6368;
  font-size: 14px;
  border-left: 4px solid #f9ab00;
}

.FailedAIMsgs_attemptedAnswer__DSC3b strong {
  color: #b06000;
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.FailedAIMsgs_resolvedAnswer__OUacC {
  background: #e6f4ea;
  padding: 16px;
  border-radius: 10px;
  margin-bottom: 16px;
  border-left: 4px solid #34a853;
  font-size: 14px;
}

.FailedAIMsgs_resolvedAnswerStrong__UvZ3b {
  color: #137333;
  display: block;
  margin-bottom: 8px;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.FailedAIMsgs_resolvedMeta__9u42W {
  font-size: 12px;
  color: #5f6368;
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px dashed #34a853;
}

.FailedAIMsgs_metadata__SFZyA {
  display: flex;
  gap: 20px;
  font-size: 13px;
  color: #5f6368;
  margin-bottom: 16px;
  flex-wrap: wrap;
  background: #f8f9fa;
  padding: 10px 14px;
  border-radius: 8px;
}

.FailedAIMsgs_metadata__SFZyA span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.FailedAIMsgs_metadata__SFZyA strong {
  color: #202124;
  font-weight: 600;
}

.FailedAIMsgs_failureCount__p1Qcj {
  color: #ea4335;
  font-weight: 600;
}

.FailedAIMsgs_lowConfidenceBadge__e6OjO {
  background: #feefe3;
  color: #c26401;
  padding: 4px 8px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
}

.FailedAIMsgs_resolvedBadge__ZCJR0 {
  background: #e6f4ea;
  color: #137333;
  padding: 4px 8px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
}

.FailedAIMsgs_answerSection__0hWuM {
  margin-top: 20px;
  border-top: 1px solid #e8eaed;
  padding-top: 20px;
}

.FailedAIMsgs_answerInput__lg3-E {
  width: 100%;
  min-height: 100px;
  padding: 14px;
  border: 1px solid #dadce0;
  border-radius: 10px;
  margin-bottom: 12px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  transition: all 0.2s ease;
  background: #f8f9fa;
}

.FailedAIMsgs_answerInput__lg3-E:focus {
  outline: none;
  border-color: #1a73e8;
  background: white;
  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);
}

.FailedAIMsgs_submitButton__5PhNZ {
  background: #1a73e8;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s ease;
  letter-spacing: 0.3px;
}

.FailedAIMsgs_submitButton__5PhNZ:hover:not(:disabled) {
  background: #1557b0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.3);
}

.FailedAIMsgs_submitButton__5PhNZ:disabled {
  background: #9aa0a6;
  cursor: not-allowed;
  opacity: 0.6;
}

.FailedAIMsgs_refreshContainer__XZ4oo {
  text-align: center;
  margin-top: 30px;
}

.FailedAIMsgs_refreshButton__rQVMz {
  background: white;
  color: #1a73e8;
  border: 1px solid #dadce0;
  padding: 10px 30px;
  border-radius: 30px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.FailedAIMsgs_refreshButton__rQVMz:hover {
  background: #f1f3f4;
  border-color: #1a73e8;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

/* Loading State */
.FailedAIMsgs_loadingContainer__p2Csd {
  padding: 60px;
  text-align: center;
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.FailedAIMsgs_loadingSpinner__LrifD {
  display: inline-block;
  width: 48px;
  height: 48px;
  border: 4px solid #f1f3f4;
  border-top: 4px solid #1a73e8;
  border-radius: 50%;
  animation: FailedAIMsgs_spin__PcjVQ 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes FailedAIMsgs_spin__PcjVQ {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.FailedAIMsgs_loadingText__eY9M4 {
  font-size: 16px;
  color: #5f6368;
  font-weight: 500;
}

/* Error State */
.FailedAIMsgs_errorContainer__ACxUb {
  padding: 40px;
  text-align: center;
  background: #fce8e8;
  border-radius: 16px;
  border: 1px solid #f5c6c6;
}

.FailedAIMsgs_errorIcon__-EWgM {
  font-size: 48px;
  margin-bottom: 16px;
}

.FailedAIMsgs_errorMessage__Mw-Vi {
  color: #c5221f;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 500;
}

.FailedAIMsgs_retryButton__R6T2B {
  background: #c5221f;
  color: white;
  border: none;
  padding: 12px 32px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s ease;
}

.FailedAIMsgs_retryButton__R6T2B:hover {
  background: #a50e0e;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(197, 34, 31, 0.3);
}

/* Access Denied Popup */
.FailedAIMsgs_accessDeniedOverlay__EtMXy {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: FailedAIMsgs_fadeIn__CclFe 0.3s ease;
}

@keyframes FailedAIMsgs_fadeIn__CclFe {
  from { opacity: 0; }
  to { opacity: 1; }
}

.FailedAIMsgs_accessDeniedPopup__FWALq {
  background: white;
  border-radius: 24px;
  padding: 40px;
  max-width: 400px;
  width: 90%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: FailedAIMsgs_slideUp__5C7Hb 0.3s ease;
}

@keyframes FailedAIMsgs_slideUp__5C7Hb {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.FailedAIMsgs_accessDeniedIcon__G8tW5 {
  font-size: 64px;
  margin-bottom: 20px;
  animation: FailedAIMsgs_shake__zOiMT 0.5s ease;
}

@keyframes FailedAIMsgs_shake__zOiMT {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-10px); }
  75% { transform: translateX(10px); }
}

.FailedAIMsgs_accessDeniedTitle__CEs2m {
  color: #d93025;
  margin-bottom: 12px;
  font-size: 28px;
  font-weight: 600;
}

.FailedAIMsgs_accessDeniedMessage__3397P {
  color: #5f6368;
  margin-bottom: 24px;
  line-height: 1.6;
  font-size: 16px;
}

.FailedAIMsgs_accessDeniedUserInfo__2a2UU {
  background: #f1f3f4;
  padding: 16px;
  border-radius: 12px;
  margin-bottom: 24px;
  font-size: 14px;
  color: #202124;
  text-align: left;
}

.FailedAIMsgs_accessDeniedUserInfo__2a2UU strong {
  color: #5f6368;
  display: inline-block;
  width: 100px;
}

.FailedAIMsgs_accessDeniedButton__vYNSi {
  background: #1a73e8;
  color: white;
  border: none;
  padding: 14px 36px;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  letter-spacing: 0.5px;
}

.FailedAIMsgs_accessDeniedButton__vYNSi:hover {
  background: #1557b0;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(26, 115, 232, 0.3);
}

/* Non-admin View */
.FailedAIMsgs_nonAdminContainer__YAdPd {
  padding: 60px 20px;
  text-align: center;
  max-width: 500px;
  margin: 0 auto;
  background: white;
  border-radius: 24px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.1);
}

.FailedAIMsgs_nonAdminIcon__wirQ1 {
  font-size: 72px;
  margin-bottom: 24px;
  animation: FailedAIMsgs_wave__PjLsv 2s infinite;
}

@keyframes FailedAIMsgs_wave__PjLsv {
  0%, 100% { transform: rotate(0deg); }
  25% { transform: rotate(10deg); }
  75% { transform: rotate(-10deg); }
}

.FailedAIMsgs_nonAdminTitle__pK3OH {
  color: #202124;
  margin-bottom: 16px;
  font-size: 24px;
  font-weight: 600;
}

.FailedAIMsgs_nonAdminMessage__eI8ik {
  color: #5f6368;
  line-height: 1.6;
  font-size: 16px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .FailedAIMsgs_container__pLo\\+P {
    padding: 12px;
  }

  .FailedAIMsgs_header__spTRa {
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
  }

  .FailedAIMsgs_filterTabs__jB0nU {
    width: 100%;
  }

  .FailedAIMsgs_filterButton__rmT1a {
    flex: 1 1;
  }

  .FailedAIMsgs_statsSummary__mPS\\+x {
    grid-template-columns: 1fr;
  }

  .FailedAIMsgs_sortControls__xP-J7 {
    flex-direction: column;
    align-items: stretch;
  }

  .FailedAIMsgs_sortButton__KP\\+je {
    text-align: center;
  }

  .FailedAIMsgs_metadata__SFZyA {
    flex-direction: column;
    gap: 8px;
  }

  .FailedAIMsgs_failureBadge__iWUhf {
    position: static;
    margin-bottom: 12px;
    display: inline-block;
  }

  .FailedAIMsgs_questionText__5wZzu {
    padding-right: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/FailedAIMsgs/FailedAIMsgs.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,uDAAuD;EACvD,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,4CAA4C;EAC5C,gDAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,sDAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+CAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,0CAA0C;EAC1C,gDAA4B;AAC9B;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,8CAA0B;AAC5B;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,4BAA4B,EAAE;EACpC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,+CAA2B;AAC7B;;AAEA;EACE,WAAW,uBAAuB,EAAE;EACpC,MAAM,wBAAwB,EAAE;EAChC,MAAM,yBAAyB,EAAE;AACnC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".container {\n  padding: 20px;\n  max-width: 900px;\n  margin: 0 auto;\n  background: #f8f9fa;\n  min-height: 100vh;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  gap: 15px;\n  background: white;\n  padding: 20px;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n}\n\n.title {\n  margin: 0;\n  font-size: 24px;\n  color: #1a1a1a;\n  font-weight: 600;\n}\n\n.filterTabs {\n  display: flex;\n  gap: 8px;\n  background: #f1f3f4;\n  padding: 4px;\n  border-radius: 8px;\n}\n\n.filterButton {\n  padding: 8px 16px;\n  background: transparent;\n  color: #5f6368;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.filterButton:hover {\n  background: rgba(0,0,0,0.05);\n  color: #202124;\n}\n\n.filterActive {\n  background: white !important;\n  color: #1a73e8 !important;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n}\n\n.filterActive:hover {\n  background: white !important;\n  color: #1557b0 !important;\n}\n\n/* Stats Summary Cards - New */\n.statsSummary {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 15px;\n  margin-bottom: 24px;\n}\n\n.statCard {\n  background: white;\n  padding: 20px;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  transition: transform 0.2s ease;\n}\n\n.statCard:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n}\n\n.statIcon {\n  font-size: 32px;\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f1f3f4;\n  border-radius: 12px;\n}\n\n.statInfo {\n  flex: 1;\n}\n\n.statLabel {\n  font-size: 14px;\n  color: #5f6368;\n  margin-bottom: 4px;\n}\n\n.statValue {\n  font-size: 28px;\n  font-weight: 600;\n  color: #202124;\n  line-height: 1.2;\n}\n\n.statSubValue {\n  font-size: 12px;\n  color: #5f6368;\n  margin-top: 2px;\n}\n\n.sortControls {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n  padding: 12px 16px;\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.sortLabel {\n  font-size: 14px;\n  color: #5f6368;\n  font-weight: 500;\n}\n\n.sortButton {\n  padding: 6px 14px;\n  background: #f1f3f4;\n  color: #5f6368;\n  border: 1px solid transparent;\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.sortButton:hover {\n  background: #e8eaed;\n  color: #202124;\n}\n\n.sortActive {\n  background: #e8f0fe !important;\n  color: #1a73e8 !important;\n  border-color: #1a73e8 !important;\n}\n\n.emptyState {\n  text-align: center;\n  padding: 60px 40px;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n}\n\n.emptyStateIcon {\n  font-size: 64px;\n  margin-bottom: 16px;\n  opacity: 0.7;\n}\n\n.emptyStateText {\n  font-size: 18px;\n  color: #5f6368;\n  font-weight: 500;\n}\n\n.emptyStateSubtext {\n  font-size: 14px;\n  color: #9aa0a6;\n  margin-top: 8px;\n}\n\n.questionCard {\n  background: white;\n  border: 1px solid #e8eaed;\n  border-radius: 16px;\n  padding: 24px;\n  margin-bottom: 16px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n  position: relative;\n  transition: all 0.2s ease;\n}\n\n.questionCard:hover {\n  box-shadow: 0 4px 16px rgba(0,0,0,0.1);\n  transform: translateY(-2px);\n}\n\n/* Resolved Card Styling */\n.resolvedCard {\n  background: #f8f9fa;\n  border-left: 6px solid #34a853;\n  opacity: 0.95;\n}\n\n.resolvedCard .questionText {\n  color: #202124;\n  opacity: 0.9;\n}\n\n/* All View Card Styling - New */\n.allViewCard {\n  background: linear-gradient(to right, #ffffff, #f8f9fa);\n  border: 1px solid #dadce0;\n}\n\n.allViewCard .metadata {\n  background: #f1f3f4;\n  padding: 12px;\n  border-radius: 8px;\n  margin-top: 12px;\n}\n\n.failureBadge {\n  position: absolute;\n  top: -10px;\n  right: 20px;\n  background: #ea4335;\n  color: white;\n  border-radius: 20px;\n  padding: 4px 14px;\n  font-size: 12px;\n  font-weight: 600;\n  box-shadow: 0 2px 8px rgba(234, 67, 53, 0.3);\n  animation: pulse 2s infinite;\n  z-index: 1;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.questionText {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 12px;\n  color: #202124;\n  padding-right: 100px;\n}\n\n.attemptedAnswer {\n  background: #fef7e0;\n  padding: 14px;\n  border-radius: 10px;\n  margin-bottom: 16px;\n  color: #5f6368;\n  font-size: 14px;\n  border-left: 4px solid #f9ab00;\n}\n\n.attemptedAnswer strong {\n  color: #b06000;\n  display: block;\n  margin-bottom: 6px;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.resolvedAnswer {\n  background: #e6f4ea;\n  padding: 16px;\n  border-radius: 10px;\n  margin-bottom: 16px;\n  border-left: 4px solid #34a853;\n  font-size: 14px;\n}\n\n.resolvedAnswerStrong {\n  color: #137333;\n  display: block;\n  margin-bottom: 8px;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.resolvedMeta {\n  font-size: 12px;\n  color: #5f6368;\n  margin-top: 10px;\n  padding-top: 8px;\n  border-top: 1px dashed #34a853;\n}\n\n.metadata {\n  display: flex;\n  gap: 20px;\n  font-size: 13px;\n  color: #5f6368;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n  background: #f8f9fa;\n  padding: 10px 14px;\n  border-radius: 8px;\n}\n\n.metadata span {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.metadata strong {\n  color: #202124;\n  font-weight: 600;\n}\n\n.failureCount {\n  color: #ea4335;\n  font-weight: 600;\n}\n\n.lowConfidenceBadge {\n  background: #feefe3;\n  color: #c26401;\n  padding: 4px 8px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.resolvedBadge {\n  background: #e6f4ea;\n  color: #137333;\n  padding: 4px 8px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.answerSection {\n  margin-top: 20px;\n  border-top: 1px solid #e8eaed;\n  padding-top: 20px;\n}\n\n.answerInput {\n  width: 100%;\n  min-height: 100px;\n  padding: 14px;\n  border: 1px solid #dadce0;\n  border-radius: 10px;\n  margin-bottom: 12px;\n  font-size: 14px;\n  font-family: inherit;\n  resize: vertical;\n  transition: all 0.2s ease;\n  background: #f8f9fa;\n}\n\n.answerInput:focus {\n  outline: none;\n  border-color: #1a73e8;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);\n}\n\n.submitButton {\n  background: #1a73e8;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  letter-spacing: 0.3px;\n}\n\n.submitButton:hover:not(:disabled) {\n  background: #1557b0;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.3);\n}\n\n.submitButton:disabled {\n  background: #9aa0a6;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.refreshContainer {\n  text-align: center;\n  margin-top: 30px;\n}\n\n.refreshButton {\n  background: white;\n  color: #1a73e8;\n  border: 1px solid #dadce0;\n  padding: 10px 30px;\n  border-radius: 30px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n}\n\n.refreshButton:hover {\n  background: #f1f3f4;\n  border-color: #1a73e8;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n}\n\n/* Loading State */\n.loadingContainer {\n  padding: 60px;\n  text-align: center;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n}\n\n.loadingSpinner {\n  display: inline-block;\n  width: 48px;\n  height: 48px;\n  border: 4px solid #f1f3f4;\n  border-top: 4px solid #1a73e8;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loadingText {\n  font-size: 16px;\n  color: #5f6368;\n  font-weight: 500;\n}\n\n/* Error State */\n.errorContainer {\n  padding: 40px;\n  text-align: center;\n  background: #fce8e8;\n  border-radius: 16px;\n  border: 1px solid #f5c6c6;\n}\n\n.errorIcon {\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n\n.errorMessage {\n  color: #c5221f;\n  margin-bottom: 20px;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.retryButton {\n  background: #c5221f;\n  color: white;\n  border: none;\n  padding: 12px 32px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n}\n\n.retryButton:hover {\n  background: #a50e0e;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(197, 34, 31, 0.3);\n}\n\n/* Access Denied Popup */\n.accessDeniedOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.accessDeniedPopup {\n  background: white;\n  border-radius: 24px;\n  padding: 40px;\n  max-width: 400px;\n  width: 90%;\n  text-align: center;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: slideUp 0.3s ease;\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.accessDeniedIcon {\n  font-size: 64px;\n  margin-bottom: 20px;\n  animation: shake 0.5s ease;\n}\n\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  25% { transform: translateX(-10px); }\n  75% { transform: translateX(10px); }\n}\n\n.accessDeniedTitle {\n  color: #d93025;\n  margin-bottom: 12px;\n  font-size: 28px;\n  font-weight: 600;\n}\n\n.accessDeniedMessage {\n  color: #5f6368;\n  margin-bottom: 24px;\n  line-height: 1.6;\n  font-size: 16px;\n}\n\n.accessDeniedUserInfo {\n  background: #f1f3f4;\n  padding: 16px;\n  border-radius: 12px;\n  margin-bottom: 24px;\n  font-size: 14px;\n  color: #202124;\n  text-align: left;\n}\n\n.accessDeniedUserInfo strong {\n  color: #5f6368;\n  display: inline-block;\n  width: 100px;\n}\n\n.accessDeniedButton {\n  background: #1a73e8;\n  color: white;\n  border: none;\n  padding: 14px 36px;\n  border-radius: 30px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  letter-spacing: 0.5px;\n}\n\n.accessDeniedButton:hover {\n  background: #1557b0;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(26, 115, 232, 0.3);\n}\n\n/* Non-admin View */\n.nonAdminContainer {\n  padding: 60px 20px;\n  text-align: center;\n  max-width: 500px;\n  margin: 0 auto;\n  background: white;\n  border-radius: 24px;\n  box-shadow: 0 8px 30px rgba(0,0,0,0.1);\n}\n\n.nonAdminIcon {\n  font-size: 72px;\n  margin-bottom: 24px;\n  animation: wave 2s infinite;\n}\n\n@keyframes wave {\n  0%, 100% { transform: rotate(0deg); }\n  25% { transform: rotate(10deg); }\n  75% { transform: rotate(-10deg); }\n}\n\n.nonAdminTitle {\n  color: #202124;\n  margin-bottom: 16px;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.nonAdminMessage {\n  color: #5f6368;\n  line-height: 1.6;\n  font-size: 16px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .container {\n    padding: 12px;\n  }\n\n  .header {\n    flex-direction: column;\n    align-items: stretch;\n    padding: 16px;\n  }\n\n  .filterTabs {\n    width: 100%;\n  }\n\n  .filterButton {\n    flex: 1;\n  }\n\n  .statsSummary {\n    grid-template-columns: 1fr;\n  }\n\n  .sortControls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .sortButton {\n    text-align: center;\n  }\n\n  .metadata {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .failureBadge {\n    position: static;\n    margin-bottom: 12px;\n    display: inline-block;\n  }\n\n  .questionText {\n    padding-right: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FailedAIMsgs_container__pLo+P`,
	"header": `FailedAIMsgs_header__spTRa`,
	"title": `FailedAIMsgs_title__-JGt9`,
	"filterTabs": `FailedAIMsgs_filterTabs__jB0nU`,
	"filterButton": `FailedAIMsgs_filterButton__rmT1a`,
	"filterActive": `FailedAIMsgs_filterActive__BIBFF`,
	"statsSummary": `FailedAIMsgs_statsSummary__mPS+x`,
	"statCard": `FailedAIMsgs_statCard__O59eR`,
	"statIcon": `FailedAIMsgs_statIcon__eygCr`,
	"statInfo": `FailedAIMsgs_statInfo__xazhV`,
	"statLabel": `FailedAIMsgs_statLabel__wvQFw`,
	"statValue": `FailedAIMsgs_statValue__YRc+p`,
	"statSubValue": `FailedAIMsgs_statSubValue__Qauxs`,
	"sortControls": `FailedAIMsgs_sortControls__xP-J7`,
	"sortLabel": `FailedAIMsgs_sortLabel__LZPHf`,
	"sortButton": `FailedAIMsgs_sortButton__KP+je`,
	"sortActive": `FailedAIMsgs_sortActive__rBMHn`,
	"emptyState": `FailedAIMsgs_emptyState__Vmr6Y`,
	"emptyStateIcon": `FailedAIMsgs_emptyStateIcon__5T5Jv`,
	"emptyStateText": `FailedAIMsgs_emptyStateText__rnpdR`,
	"emptyStateSubtext": `FailedAIMsgs_emptyStateSubtext__9nb+o`,
	"questionCard": `FailedAIMsgs_questionCard__Opc7m`,
	"resolvedCard": `FailedAIMsgs_resolvedCard__mf5cZ`,
	"questionText": `FailedAIMsgs_questionText__5wZzu`,
	"allViewCard": `FailedAIMsgs_allViewCard__Y9e1k`,
	"metadata": `FailedAIMsgs_metadata__SFZyA`,
	"failureBadge": `FailedAIMsgs_failureBadge__iWUhf`,
	"pulse": `FailedAIMsgs_pulse__0p8Kc`,
	"attemptedAnswer": `FailedAIMsgs_attemptedAnswer__DSC3b`,
	"resolvedAnswer": `FailedAIMsgs_resolvedAnswer__OUacC`,
	"resolvedAnswerStrong": `FailedAIMsgs_resolvedAnswerStrong__UvZ3b`,
	"resolvedMeta": `FailedAIMsgs_resolvedMeta__9u42W`,
	"failureCount": `FailedAIMsgs_failureCount__p1Qcj`,
	"lowConfidenceBadge": `FailedAIMsgs_lowConfidenceBadge__e6OjO`,
	"resolvedBadge": `FailedAIMsgs_resolvedBadge__ZCJR0`,
	"answerSection": `FailedAIMsgs_answerSection__0hWuM`,
	"answerInput": `FailedAIMsgs_answerInput__lg3-E`,
	"submitButton": `FailedAIMsgs_submitButton__5PhNZ`,
	"refreshContainer": `FailedAIMsgs_refreshContainer__XZ4oo`,
	"refreshButton": `FailedAIMsgs_refreshButton__rQVMz`,
	"loadingContainer": `FailedAIMsgs_loadingContainer__p2Csd`,
	"loadingSpinner": `FailedAIMsgs_loadingSpinner__LrifD`,
	"spin": `FailedAIMsgs_spin__PcjVQ`,
	"loadingText": `FailedAIMsgs_loadingText__eY9M4`,
	"errorContainer": `FailedAIMsgs_errorContainer__ACxUb`,
	"errorIcon": `FailedAIMsgs_errorIcon__-EWgM`,
	"errorMessage": `FailedAIMsgs_errorMessage__Mw-Vi`,
	"retryButton": `FailedAIMsgs_retryButton__R6T2B`,
	"accessDeniedOverlay": `FailedAIMsgs_accessDeniedOverlay__EtMXy`,
	"fadeIn": `FailedAIMsgs_fadeIn__CclFe`,
	"accessDeniedPopup": `FailedAIMsgs_accessDeniedPopup__FWALq`,
	"slideUp": `FailedAIMsgs_slideUp__5C7Hb`,
	"accessDeniedIcon": `FailedAIMsgs_accessDeniedIcon__G8tW5`,
	"shake": `FailedAIMsgs_shake__zOiMT`,
	"accessDeniedTitle": `FailedAIMsgs_accessDeniedTitle__CEs2m`,
	"accessDeniedMessage": `FailedAIMsgs_accessDeniedMessage__3397P`,
	"accessDeniedUserInfo": `FailedAIMsgs_accessDeniedUserInfo__2a2UU`,
	"accessDeniedButton": `FailedAIMsgs_accessDeniedButton__vYNSi`,
	"nonAdminContainer": `FailedAIMsgs_nonAdminContainer__YAdPd`,
	"nonAdminIcon": `FailedAIMsgs_nonAdminIcon__wirQ1`,
	"wave": `FailedAIMsgs_wave__PjLsv`,
	"nonAdminTitle": `FailedAIMsgs_nonAdminTitle__pK3OH`,
	"nonAdminMessage": `FailedAIMsgs_nonAdminMessage__eI8ik`
};
export default ___CSS_LOADER_EXPORT___;
